import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

const toArabicDigits = (num) =>
  num.toString().replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);

export default function MyPagination({ totalPages, page, setPage }) {
  const { i18n } = useTranslation();
  const isArabic = i18n.language.startsWith("ar");

  const getPageLabel = (p) => (isArabic ? toArabicDigits(p) : p);

  const renderPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(1, page - 2);
    const endPage = Math.min(totalPages, page + 2);

    for (let i = startPage; i <= endPage; i++) {
        pages.push(
            <button
                key={i}
                onClick={() => setPage(i)}
                className={`w-10 h-10 rounded-xl font-bold transition-all duration-300 ${
                    page === i
                    ? "bg-[#0f7699] text-white shadow-[0_0_15px_rgba(15,118,153,0.4)]"
                    : "text-slate-400 hover:text-white hover:bg-white/10"
                }`}
            >
                {getPageLabel(i)}
            </button>
        );
    }
    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center gap-2 ${isArabic ? "flex-row-reverse" : "flex-row"}`}>
      {/* First Page */}
      <button
        onClick={() => setPage(1)}
        disabled={page === 1}
        className="p-2.5 rounded-xl text-slate-500 hover:text-white hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
      >
        {isArabic ? <ChevronsRight size={18} /> : <ChevronsLeft size={18} />}
      </button>

      {/* Prev Page */}
      <button
        onClick={() => setPage(Math.max(1, page - 1))}
        disabled={page === 1}
        className="p-2.5 rounded-xl text-slate-500 hover:text-white hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
      >
        {isArabic ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
      </button>

      {/* Page Numbers */}
      <div className="flex items-center gap-1 mx-2">
        {renderPageNumbers()}
      </div>

      {/* Next Page */}
      <button
        onClick={() => setPage(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="p-2.5 rounded-xl text-slate-500 hover:text-white hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
      >
        {isArabic ? <ChevronLeft size={18} /> : <ChevronRight size={18} />}
      </button>

      {/* Last Page */}
      <button
        onClick={() => setPage(totalPages)}
        disabled={page === totalPages}
        className="p-2.5 rounded-xl text-slate-500 hover:text-white hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
      >
        {isArabic ? <ChevronsLeft size={18} /> : <ChevronsRight size={18} />}
      </button>
    </div>
  );
}
